import React, { useState, useEffect } from "react";
import TreeView from "react-treeview";
import {
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
  Form,
} from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import "react-treeview/react-treeview.css";
import { ProfileService } from "../../../../../services/ProfileService";
import { JobService } from "../../../../../services/JobService";
import "../../../../../assets/css/overridestyles.css";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";
const Certification = (props) => {
  const [modalRight, setModalRight] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [filteredCertifications, setFilteredCertifications] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [modalNestedContainer, setmodalNestedContainer] = useState(false);
  const [languageshow, setlanguageShow] = useState(true);
  const [buttonShow, setButtonShow] = useState(true);
  const [scategories, setSCategories] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [certificationId, setCertificationId] = useState("");
  const [ceritificationName, setCeritificationName] = useState("");
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [selectedSkillId, setSelectedSkillId] = useState("");
  const [candidateCertificationsList, setCandidateCertificationsList] =
    useState([]);

  useEffect(() => {
    getTotalCertificationsList();
    getTotalCandidateCertificationsList();
  }, []);

  const getTotalCertificationsList = () => {
    JobService.getCertifications().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails !== null) {
          let certifications = skillDetails.indlist;
          if(certifications!=null){
            if(certifications.length>0){
              setCategories(certifications);
              setFilteredCertifications(certifications);
              updateJobCertificationList(certifications);
            }            
          }         
        }
      } catch (err) {
        console.error("getCertifications" + JSON.stringify(err));
      }
    });
  };

  const getTotalCandidateCertificationsList = () => {
    ProfileService.getProfileCertifications().then((response) => {
      try {
        let certifications = response.data;
        if (certifications != null) {
          let certificationSkills = certifications.skills;
          if (certificationSkills !== null) {
            if (certificationSkills.length > 0) {
              setCandidateCertificationsList(certificationSkills);
              if (props.certifications == undefined) {
                setSCategories(certificationSkills);
                setSelectedCertifications(certificationSkills);
                return;
              }

              let candidateJobCertifications = matchJobCertifications(
                props.certifications,
                certificationSkills
              );
              let candidateJobCertificationList = [
                ...candidateJobCertifications,
              ];
              if (candidateJobCertificationList.length > 0) {
                props.candidateJobCertifications(candidateJobCertificationList);

                certificationSkills.map((skill) => {
                  candidateJobCertificationList.push(skill);
                });
                setSCategories([]);
                setSCategories(candidateJobCertificationList);
              } else {
                setSCategories([]);
                setSCategories(certificationSkills);
              }
            } else {
              setCandidateCertificationsList([]);
              setSCategories([]);
              setSelectedCertifications([]);
              if (props.certifications == undefined) {
                return;
              }
              let candidateJobCertifications = matchJobCertifications(
                props.certifications,
                certificationSkills
              );
              setSCategories(candidateJobCertifications);
              props.candidateJobCertifications(candidateJobCertifications);
            }
          } else {
            setCandidateCertificationsList([]);
            setSCategories([]);
            setSelectedCertifications([]);
            if (props.certifications == undefined) {
              return;
            }
            let candidateJobCertifications = matchJobCertifications(
              props.certifications,
              certificationSkills
            );
            setSCategories(candidateJobCertifications);
            props.candidateJobCertifications(candidateJobCertifications);
          }
        }
      } catch (err) {
        console.error("getProfileCertifications" + JSON.stringify(err));
      }
    });
  };

  const updateJobCertificationList = (certifications) => {
    certifications.map((industrydetails, index) => {
      industrydetails.categories.length > 0 &&
        industrydetails.categories.map((category, index) => {
          category.skills.length > 0 &&
            category.skills.map((skill, index) => {
              skill.isChecked = false;
            });
        });
    });
    setFilteredCertifications(certifications);
  };

  const matchJobCertifications = (
    jobCertifications,
    candidateCertifications
  ) => {
    let candidateJobCertificatons = [];
    let jobCertificationDetails = jobCertifications;
    if (
      jobCertificationDetails !== null ||
      jobCertificationDetails !== undefined
    ) {
      if (jobCertificationDetails.length > 0) {
        const data = [];
        jobCertificationDetails.map((skill) => {
          if (sessionStorage.getItem("removedCertifications") !== null) {
            var retrievedData = sessionStorage.getItem("removedCertifications");
            var removedList = JSON.parse(retrievedData);
            if (removedList.length > 0) {
              const isFound = removedList.some((element, index) => {
                if (element === skill.skillId) {
                  return true;
                }
                return false;
              });
              if (!isFound) {
                data.push(skill);
              }
            }
          } else {
            data.push(skill);
          }
        });

        const updatedJobDetails = [];
        for (let i = 0; i < data.length; i++) {
          let skill = data[i];
          if (candidateCertifications.length > 0) {
            const isFound = candidateCertifications.some((element, index) => {
              if (element.skillId === skill.skillId) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              updatedJobDetails.push(skill);
            }
          } else {
            updatedJobDetails.push(skill);
          }
        }
        candidateJobCertificatons = [...updatedJobDetails];
      }
    }
    return candidateJobCertificatons;
  };

  const handleCheck = (event, softSkills) => {
    let skillId = softSkills.skillId;
    var updatedList = [...selectedSkills];
    let certifications = [...filteredCertifications];
    if (event.target.checked) {
      updatedList.push(softSkills.skillId);
      const isFound = selectedCertifications.some((element) => {
        if (element.skillId === selectedCertifications.skillId) {
          return true;
        }
        return false;
      });
      if (isFound) {
      } else {
        selectedCertifications.push({
          skillId: softSkills.skillId,
        });
      }

      certifications.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, index) => {
                let categorySkillId = skill.skillId;
                if (categorySkillId == skillId) {
                  skill.isChecked = true;
                }
              });
          });
      });
    } else {
      certifications.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, index) => {
                let categorySkillId = skill.skillId;
                if (categorySkillId == skillId) {
                  skill.isChecked = false;
                }
              });
          });
      });

      for (var i = 0; i < selectedCertifications.length; i++) {
        if (selectedCertifications[i].skillId == softSkills.skillId) {
          selectedCertifications.splice(i, 1);
          break;
        }
      }

      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == softSkills.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setFilteredCertifications(certifications);
    setSelectedCertifications(selectedCertifications);
    setSelectedSkills(updatedList);
  };

  const addCertificationDetails = () => {
    const certificationData = [];
    selectedCertifications.map((certification) => {
      certificationData.push({
        skillId: certification.skillId,
      });
    });
    const certificationObject = {
      skills: certificationData,
    };

    if (selectedCertifications.length > 0) {
      setSaveBtnEnabled(true);
      ProfileService.saveCertification(certificationObject).then((response) => {
        setSaveBtnEnabled(false);
        try {
          if (response.data != null) {
            getTotalCandidateCertificationsList();
            setModalRight(false);
          }
        } catch (err) {
          console.error("saveCertification" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showErrorMessage(Constants.selectCertification)
    }
  };

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    if (searchInput !== "" && searchInput.length >= 3) {
      JobService.searchCertification(searchValue).then((response) => {
        try {
          if (response.data != null) {
            setFilteredCertifications(response.data.indlist);
          }
        } catch (err) {
          console.error("searchCertification" + JSON.stringify(err));
        }
      });
    } else {
      setFilteredCertifications(categories);
    }
  };

  const onAddCetifications = () => {
    setSelectedSkills([]);
    setModalRight(true);
    setlanguageShow(true);
    setButtonShow(true);
    resetCertificanDetails(categories);
  };

  const resetCertificanDetails = (certifications) => {
    let certificationList = [];
    let selectedCertificationList = [];
    if (scategories.length > 0) {
      scategories.map((category) => {
        let skillId = category.skillId;
        certificationList.push(skillId);
        selectedCertificationList.push({
          skillId: skillId,
        });
      });

      certifications.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, index) => {
                skill.isChecked = false;
                const isFound = scategories.some((element) => {
                  if (element.skillId === skill.skillId) {
                    return true;
                  }
                  return false;
                });
                if (isFound) {
                  skill.isChecked = true;
                } else {
                  skill.isChecked = false;
                }
              });
          });
      });
      setSelectedSkills(certificationList);
      setSelectedCertifications(selectedCertificationList);
    } else {
      certifications.map((industrydetails, index) => {
        industrydetails.categories.length > 0 &&
          industrydetails.categories.map((category, index) => {
            category.skills.length > 0 &&
              category.skills.map((skill, index) => {
                skill.isChecked = false;
              });
          });
      });
      setSelectedSkills([]);
      setSelectedCertifications([]);
    }
    setFilteredCertifications(certifications);
  };
  const handledeletesoftskill = (skill) => {
    let id = skill.id;
    let name = skill.name;
    let skillId = skill.skillId;
    setCertificationId(id);
    setCeritificationName(name);
    // setmodalNestedContainer(true);
    setSelectedSkillId(skillId);
    removeCertificationDetails(id);
  };

  const removeCertificationDetails = (certificationId) => {
    if (candidateCertificationsList.length > 0) {
      ProfileService.deleteCandidateSkill(certificationId).then((response) => {
        try {
        //  toast.success("Certification deleted successfully");
          setSCategories([]);
          updateDetails();
          getTotalCandidateCertificationsList();
          setmodalNestedContainer(false);
        } catch (err) {
          console.error("deleteCandidateSkill" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showSuccessMessage(Constants.certificationDeleted);
      updateDetails();
      setSCategories([]);
      getTotalCandidateCertificationsList();
      setmodalNestedContainer(false);
    }
  };

  const updateDetails = () => {
    const certifications = [];
    if (sessionStorage.getItem("removedCertifications") !== null) {
      var retrievedData = sessionStorage.getItem("removedCertifications");
      var removedList = JSON.parse(retrievedData);
      if (removedList.length > 0) {
        const data = [...removedList];
        const isFound = data.some((element) => {
          if (element === selectedSkillId) {
            return true;
          }
          return false;
        });
        if (!isFound) {
          data.push(selectedSkillId);
          sessionStorage.setItem("removedCertifications", JSON.stringify(data));
        }
      } else {
        certifications.push(selectedSkillId);
        sessionStorage.setItem(
          "removedCertifications",
          JSON.stringify(certifications)
        );
      }
    } else {
      certifications.push(selectedSkillId);
      sessionStorage.setItem(
        "removedCertifications",
        JSON.stringify(certifications)
      );
    }
  };

  const back = () => {
    setmodalNestedContainer(false);
  };

  return (
    <div>
      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
          className="skill-model-width"
        >
          <ModalHeader>
            <div>
              <strong>Select your certifications</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="row mb-3">
              <div className="col-sm-12">
                <Input
                  type="text"
                  icon="search"
                  placeholder="Search for certifications"
                  onChange={(e) => searchItems(e.target.value)}
                />
              </div>
            </div>
            {languageshow && (
              <>
                {filteredCertifications.length > 0 &&
                  filteredCertifications.map((industrydetails, index) => {
                    return (
                      <div key={index}>
                        <TreeView
                          nodeLabel={industrydetails.industry}
                          defaultCollapsed={false}
                          className="treeViewIconSize"
                        >
                          <div className="col ">
                            {industrydetails.categories.length > 0 &&
                              industrydetails.categories.map(
                                (category, index) => {
                                  return (
                                    <div key={index}>
                                      {category.name == null ||
                                      category.name == " " ? (
                                        <div>
                                          {category.skills.length > 0 &&
                                            category.skills.map(
                                              (skill, index) => {
                                                return (
                                                  <div key={index}>
                                                    <div className="col-12">
                                                      <div className="row">
                                                        <div className="col-sm-12 mt-2">
                                                          <label className="terms">
                                                            <input
                                                              data-testid="privacypolicy"
                                                              type="checkbox"
                                                              className="input_skill"
                                                              checked={selectedSkills.find(
                                                                (ch) =>
                                                                  ch ===
                                                                  skill.skillId
                                                              )}
                                                              onChange={(e) =>
                                                                handleCheck(
                                                                  e,
                                                                  skill
                                                                )
                                                              }
                                                            />
                                                            <label>
                                                              <div className="terms">
                                                                {" "}
                                                                {
                                                                  skill.name
                                                                }{" "}
                                                              </div>
                                                            </label>
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                        </div>
                                      ) : (
                                        <div>
                                          <TreeView
                                            nodeLabel={category.name}
                                            defaultCollapsed={false}
                                            className="treeViewIconSize"
                                          >
                                            <div>
                                              {category.skills.length > 0 &&
                                                category.skills.map(
                                                  (skill, index) => {
                                                    return (
                                                      <div key={index}>
                                                        <div className="col-12">
                                                          <div className="row">
                                                            <div className="col-sm-12">
                                                              <label className="terms">
                                                                <input
                                                                  data-testid="privacypolicy"
                                                                  type="checkbox"
                                                                  className="input_skill"
                                                                  checked={
                                                                    skill.isChecked
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleCheck(
                                                                      e,
                                                                      skill
                                                                    )
                                                                  }
                                                                />{" "}
                                                                {skill.name}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                            </div>
                                          </TreeView>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                          </div>
                        </TreeView>
                      </div>
                    );
                  })}
                {filteredCertifications.length == 0 && (
                  <div className="t-nodata">
                    <strong>Certification not found</strong>
                  </div>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter className="t-modal-footer-btn">
           
            <TeamanicsButton
              outline
              onClick={() => setModalRight(false)}
            >
              Cancel
            </TeamanicsButton>
            <TeamanicsButton
              onClick={addCertificationDetails}
              disabled={saveBtnEnabled}
            >
              Save
            </TeamanicsButton>{" "}
          </ModalFooter>
        </Modal>
      </div>

      <Card className="mt-4 bg-primary-white min-sm:rounded-xl pt-12 mb-8 p-3">
        <CardBody className="t-body-padding[0px]">
          <div className="profile-card-title row">
            <div className="col-6">
              <label>
                <strong>Certifications</strong>
              </label>
            </div>
            <div className="col-sm-6 t-button-flex-end ">
              <TeamanicsButton
                onClick={onAddCetifications}
              >
                {/* Add certifications */}
                {scategories.length >= 2 ? (
                  <> Add more certifications</>
                ) : (
                  <> Add certifications</>
                )}
              </TeamanicsButton>
            </div>
          </div>
          {scategories.length > 0 && (
            <>
              <div className="horizontal_line mt-1 mb-3" />
              {scategories.map((skill, index) => {
                return (
                  <div className="mt-1" key={index}>
                    <Row>
                      <Colxx xxs="12">
                        <Form>
                          <FormGroup row>
                            <div className="col-10">
                              <Label>{skill.name}</Label>
                            </div>
                            <div className="col-2">
                              <span to="">
                                <i
                                  className="simple-icon-trash edit-copyiconsize arrow-icon-color emp_icon"
                                  title="Delete Certification"
                                  type="button"
                                  color="black"
                                  onClick={() => handledeletesoftskill(skill)}
                                />
                              </span>
                            </div>
                          </FormGroup>
                        </Form>
                      </Colxx>
                    </Row>
                  </div>
                );
              })}
            </>
          )}
        </CardBody>
      </Card>

      <Modal
        id="exampleModal"
        isOpen={modalNestedContainer}
        toggle={() => setmodalNestedContainer(!modalNestedContainer)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
        <ModalHeader>
          <div>
            <label className="modal-title" id="exampleModalLabel">
              <strong>Delete certification</strong>
            </label>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <label>
              Do you want to delete {ceritificationName} Certificate?
            </label>
          </div>
        </ModalBody>

        <ModalFooter className="model-button ">
          <div>
            <TeamanicsButton color="primary" outline data-dismiss="modal" onClick={back}>
              Close
            </TeamanicsButton>{" "}
            <TeamanicsButton
              color="primary"
              outline
              data-dismiss="modal"
              onClick={() => {
                removeCertificationDetails();
              }}
            >
              Delete
            </TeamanicsButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Certification;
